import ArchetypeRebel from './ArchetypeRebel'

export default ArchetypeRebel
// eslint-disable-next-line import/export
export * from './ArchetypeRebel'
